import { Progress, Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

const InitProgressBar = () => {
  const { isInitializing } = useSelector((state: RootState) => state.auth);
  const { isLoading: isLoadingWarehouse } = useSelector(
    (state: RootState) => state.warehouse
  );

  const isLoading = isInitializing || isLoadingWarehouse;

  if (!isLoading) return null;

  return (
    <>
      <Progress
        percent={isLoadingWarehouse ? 75 : 35}
        status="active"
        strokeColor="#df1818ff"
        showInfo={false}
        size="small"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          margin: 0,
          lineHeight: 0,
        }}
      />
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          zIndex: 9998,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(2px)",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <Spin size="large" />
          <div
            style={{
              marginTop: 16,
              fontSize: 16,
              fontWeight: 600,
              color: "var(--primary-color)",
            }}
          >
            {isLoadingWarehouse
              ? "Đang tải dữ liệu kho..."
              : "Đang khởi tạo..."}
          </div>
        </div>
      </div>
    </>
  );
};

export default InitProgressBar;
